//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

export const searchFilterUpdates = {
  INIT: 'init',
  ADD: 'add',
  REMOVE: 'remove',
  SET: 'set',
  UPDATES: ['add', 'remove', 'set'],
} as const;
